module.exports = __webpack_public_path__ + "img/changer-social-before.d7b7e414.jpg";